const optionCategoriesSchema = [];

export default optionCategoriesSchema;
